import { CircularProgress } from "@mui/material";
import React, { memo } from "react";

import "./styles/loading.scss";

const RouteLoading = () => {
  return (
    <div className="page-loading-container">
      <CircularProgress />
    </div>
  );
};

export default memo(RouteLoading);
